<template>
    <Modal title="Create New Brand" width="push-40" section="showCreateBrandDialog">
        <div class="card createBrand">
            <div class="card-body">
                <v-form ref="form">
                    <div class="row mt-0">
                        <div class="form-inline col-md-2 py-0">
                            <span style="padding-left: 5px;"> Name</span>
                        </div>
                        <div class="form-group col-md-5 my-0">
                            <v-text-field
                                v-model="name"
                                label="Brand Name"
                                :rules="[requiredBrandName]"
                            ></v-text-field>
                        </div><!--form-group-->
                    </div>

                    <div class="row mt-0">
                        <div class="form-inline col-md-2 py-0">
                            <span style="padding-left: 5px;"> Category</span>
                        </div>
                        <div class="form-group col-md-5 my-0">
                            <template v-if="!category_create">
                                <v-container fluid>
                                    <v-select
                                        v-model="categories"
                                        :items="all_categories"
                                        label="Category"
                                        :rules="[requiredCategory]"
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text }}</span>
                                            </v-chip>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_categories" placeholder="Search" @input="search('categories')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>

                            <v-text-field
                                v-else
                                v-model="category_name"
                                label="Category Name"
                                :rules="[requiredCategoryName]"
                            ></v-text-field>
                        </div><!--form-group-->
                        <div class="form-group col-md-2 my-0 pl-0">
                            <v-tooltip v-if="!category_create" top color="info">
                                <template v-slot:activator="{ on }">
                                    <a @click="createNewCategory" v-on="on" class="btn btn-success ml-1 text-white">
                                        <i class="fas fa-plus-circle"></i> New Category
                                    </a>
                                </template>
                                <span>Create New Category</span>
                            </v-tooltip>

                            <v-tooltip v-else top color="info">
                                <template v-slot:activator="{ on }">
                                    <a @click="createNewCategory" v-on="on" class="btn btn-info ml-1 text-white">
                                        <i class="fas fa-minus-circle"></i> Use Existing
                                    </a>
                                </template>
                                <span>Use Existing Category</span>
                            </v-tooltip>
                        </div>
                    </div>

                    <div v-if="category_create" class="row mt-0">
                        <div class="form-inline col-md-2 py-0">
                            <span style="padding-left: 5px;"> Segment</span>
                        </div>
                        <div class="form-group col-md-5 my-0">
                            <template>
                                <v-container fluid>
                                    <v-select
                                        v-model="segments"
                                        :items="all_segments"
                                        label="Segment"
                                        :rules="[requiredSegment]"
                                    >
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip small v-if="index === 0">
                                                <span>{{ item.text }}</span>
                                            </v-chip>
                                        </template>

                                        <template v-slot:prepend-item>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-text-field v-model="search_segments" placeholder="Search" @input="search('segments')"></v-text-field>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-container>
                            </template>
                        </div><!--form-group-->
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-1 text-left">
                            <button @click.prevent="close()" class="btn btn-danger">Cancel</button>
                        </div>
                        <div class="col-2 offset-9 text-right">
                            <button @click.prevent="submitData" class="btn btn-success">Create</button>
                        </div>
                    </div>
                </v-form>
            </div>
        </div><!--card-->
    </Modal>
</template>

<script>
import Modal from '../../Modal'
import api from "../../../api/my-data/poi/submissions";
import mixins from "../../../mixin";
export default {
    name: "CreateNewBrand",
    mixins: [mixins],
    components: {
        Modal
    },
    data: () => ({
        name: '',
        category_name: '',

        all_categories: [],
        all_categories_copy: [],
        categories: '',
        search_categories: '',

        all_segments: [],
        all_segments_copy: [],
        segments: '',
        search_segments: '',

        category_create: false,

        requiredBrandName: v => v && v.length > 0 || 'Brand Name field is required',
        requiredCategoryName: v => v && v.length > 0 || 'Category Name field is required',
        requiredCategory: v => v && v > 0 || 'Category field is required',
        requiredSegment: v => v && v > 0 || 'Segment field is required',
    }),
    methods: {
        async fetchCategories() {
            await api.getAllCategories()
                .then(res => {
                    this.all_categories = res.data
                    this.all_categories_copy = res.data
                })
        },
        async fetchSegments() {
            await api.getAllSegments()
                .then(res => {
                    this.all_segments = res.data
                    this.all_segments_copy = res.data
                })
        },
        async createNewBrand() {
            await api.createNewBrand({
                name: this.name,
                category: this.categories,
                category_create: this.category_create ? 2 : 1,
                category_name: this.category_name,
                segment: this.segments
            })
            .then(res => {
                this.$toast.open({
                    message: res.data.message,
                    type: "success",
                })
                this.$emit('brand-created', res.data.id)
                this.$parent.showCreateBrandDialog = false;
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
                this.$parent.showCreateBrandDialog = false;
            })
        },
        createNewCategory() {
            if (this.$store.getters.getCompanyTier.categories != null && this.$store.getters.getCompanyTierStatus.categories >= this.$store.getters.getCompanyTier.categories) {
                this.$toast.open({
                    message: 'Your company has exceeded the maximum number of custom categories. Please contact your account manager.',
                    type: "error",
                })
            } else {
                this.category_create = !this.category_create
            }
        },
        submitData() {
            if (this.$refs.form.validate()) {
                this.createNewBrand()
            }
        },
        close() {
            this.$parent.showCreateBrandDialog = false
        },
        toggle(data) {
            this.$nextTick(() => {
                if (this.selectedAll(data)) {
                    this.$data[data] = []
                } else {
                    this.$data[data] = this.$data['all_' + data].map(a => {
                        return a.value
                    })
                }
            })
        },
        search(data) {
            if (!this.$data['search_' + data]) {
                this.$data['all_' + data] = this.$data['all_' + data + '_copy'];
            }
            this.$data['all_' + data] = this.$data['all_' + data + '_copy'].filter((item) => {
                return item.text.toLowerCase().indexOf(this.$data['search_' + data].toLowerCase()) > -1;
            })
        },
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {
        this.fetchCategories()
        this.fetchSegments()
    },
}
</script>

<style>
.push-down-36 {
    margin-top: 36px;
}

.v-input--selection-controls {
    margin-top: 1px;
}

.v-date-picker-table {
    height: auto !important;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
}

.card {
    border: none;
}

.v-input--radio-group__input .checked label {
    background-color: #ff7516;
    border-color: #ff7516;
    color: #fff;
}

.v-input__slot .v-label {
    margin-bottom: 0;
}

.v-input--radio-group__input .v-radio .v-input--selection-controls__input {
    display: none;
}

.v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 32px;
    padding: 0 12px;
}

.v-dialog__content--active {
    z-index: 99998 !important;
}

.recency-options > span {
    color: #ff7516;
    border-bottom: 1px solid white;
    transition: border-bottom .3s ease-in-out;
}

.recency-options > span:hover {
    border-bottom: 1px solid #ff7516;
    cursor: pointer;
}
</style>